import React, { useEffect, useMemo, useState } from "react";
import DataTable from "react-data-table-component";
import SkeletonTicketList from "../../../loaders/SkeletonTicketList";
import Papa from "papaparse";
import * as XLSX from "xlsx";
import JsPDF from "jspdf";
import "jspdf-autotable";
import Str from "../../common/Str";
import { Link, useHistory, useLocation } from "react-router-dom";
import { TrimText } from "../../common/TrimText";
import hasPermission from "../../../utils/hasMultiplePermission";
import { useSelector } from "react-redux";
import { GetCommonContentReReg } from "../../../services/ProgrammeServices";
import {
  TABLE_ROWS_PER_PAGE,
} from "../../../utils/Constants";
import { handleTableScroll } from "../../../utils/commonFunction";
import {
  getProgrammeStudyPathModuleList,
  LinkedModuleNetsuiteProductCourseList,
  LinkedModuleNetsuiteProductCourseListFilters,
} from "../../../services/ProgramService";
import axios from "axios";
import { useParams } from "react-router-dom";
import Swal from "sweetalert2";

function CreateStudyPathModuleModel({
  data,
  detail,
  addProgramme,
  tableData1,
  setTableData1,
  tableData,
  module_type,
}) {
  const history = useHistory();
  const { id } = useParams();
  const { search:querySearch } = useLocation();
  const query = new URLSearchParams(querySearch);
  const queryProgrammeId = query.get("programmeId");
  const queryVersionId = query.get('versionId')

  const [search, setSearch] = useState("");
  const [intake, setIntake] = useState({ arr: [], checkObj: {} });
  const [campus, setCampus] = useState({ arr: [], checkObj: {} });
  const [delivery, setDelivery] = useState({ arr: [], checkObj: {} });
  const [courseType, setCourseType] = useState({ arr: [], checkObj: {} });
  const [listData, setListData] = useState([]);
  const [dropdown, setDropdown] = useState({
    intake: [],
    campus: [],
    deliveryMethod: [],
    courseType: [],
  });
  const [schoolArr, setSchoolArr] = useState([]);
  const [loading, setLoading] = useState(false);
  const [perPage, setPerPage] = useState(10);
    const [page, setPage] = useState(1);
    const [sortkey, setSortKey] = useState("name");
    const [sortOrder, setSortOrder] = useState("ASC");
  const [totalRows1, setTotalRows1] = useState(0);
  useEffect(() => {
    handleTableScroll();
  }, [loading]);

  useEffect(() => {
    const getListOfuser = async () => {
      setLoading(true);
      const apiData = {
        page: page,
        limit: perPage,
        key: sortkey,
        sort: sortOrder,
        search: search,
        exportStatus: "false",
        isAssigned: 0,
        programme_id : queryProgrammeId,
        module_type: module_type,
        id: queryProgrammeId,
        version_id : queryVersionId
      };

      try {
        const res = await getProgrammeStudyPathModuleList(apiData);
        if (res.status == 200) {
          setTableData1(res?.data.modules.data);
          setTotalRows1(res?.data.modules.total);
          setLoading(false);
        }
      } catch (error) {
        console.error(error);
        setLoading(false);
      }
    };

    getListOfuser();
  }, [search, id,perPage,page,sortkey,sortOrder,queryProgrammeId]);

  const handlePageChange = (pageNo) => {
    setPage(pageNo);
  };

  const handlePerRowsChange = (newPerPage, page) => {
    setPerPage(newPerPage);
  };

  const handleSort = (column, sortDirection) => {
    setSortKey(column.selector);
    setSortOrder(sortDirection === "asc" ? "ASC" : "DESC");
  };

  useEffect(() => {
    const getFilters = async () => {
      const response = await LinkedModuleNetsuiteProductCourseListFilters(
        (queryProgrammeId),
        detail?.netsuite_product,
        0
      );
      if (response.status === 200) {
        setDropdown({
          ...dropdown,
          intake: response.data?.yearsAndIntaksFilters,
          campus: response.data?.campusFilter,
          deliveryMethod: response.data?.intakeTypeFilters,
          courseType: response.data?.subjectTypeFilter,
        });
      }
    };
    getFilters();
  }, [detail]);

  useEffect(() => {
    const cancelTokenSources = [];
    const getData = async () => {
      cancelTokenSources.forEach((source) => {
        source.cancel("New request made");
      });

      const source = axios.CancelToken?.source();
      cancelTokenSources.push(source);
      try {
        const data = {
          module_id: queryProgrammeId,
          netsuite_product_id: detail?.netsuite_product,
          isAssigned: 0,
        };
        const response = await LinkedModuleNetsuiteProductCourseList(data);
        if (response.status === 200) {
          setListData(response.data.data.data);
        }
      } catch (error) {
        if (!axios.isCancel(error)) {
          console.log("error :", error);
        }
      }
    };

    getData();

    return () => {
      cancelTokenSources.forEach((source) => {
        source.cancel("Component unmounted");
      });
    };
  }, [detail]);

  const givenPermsisions = useSelector((state) => state.givenPermission);

  useEffect(() => {
    let response = hasPermission({
      scopes: ["matpview"],
      permissions: givenPermsisions,
    });
    if (!response) {
      history.push("/noaccess");
    }
  }, []);

  useEffect(() => {
    GetCommonContentReReg()
      .then((res) => setSchoolArr(res.data.school_type))
      .catch((err) => console.error("err in common data api :", err));
  }, []);

  const resetFilter = () => {
    setSearch("");
    setIntake({ arr: [], checkObj: {} });
    setCampus({ arr: [], checkObj: {} });
    setDelivery({ arr: [], checkObj: {} });
    setCourseType({ arr: [], checkObj: {} });
  };

  const exportData = (fileType, fileName) => {
    let data;
    const header = ["Name", "Code","Duration (Weeks)","Credits"];
    Swal.fire({
      title: "File downloading",
      onOpen: function () {
        Swal.showLoading();
      },
    });
    const cData = {
      page: page,
      limit: perPage,
      key: sortkey,
      sort: sortOrder,
      search: search,
      exportStatus: "true",
      isAssigned: 0,
      programme_id: queryProgrammeId,
      module_type: module_type,
      id: queryProgrammeId,
    }
    getProgrammeStudyPathModuleList(cData).then(res => {
      data = res.data?.modules;
      data = data?.map((row, ind) => ({
        ...row,
        "Name": row.name ? row.name : "-",
        "Code" : row.Code ? row.Code: "-",
        "Duration (Weeks)": row.Duration ? row.Duration : "-",
        "Credits" : row.credits ? row.credits : "-",
      }));
      if (fileType === "csv") {
        const csvString = Papa.unparse({ fields: header, data });
        const blob = new Blob([csvString], { type: "text/csv;charset=utf-8," });

        const blobURL = window.URL.createObjectURL(blob);

        // Create new tag for download file
        const anchor = document.createElement("a");
        anchor.download = fileName;
        anchor.href = blobURL;
        anchor.dataset.downloadurl = ["text/csv", anchor.download, anchor.href].join(":");
        anchor.click();

        // Remove URL.createObjectURL. The browser should not save the reference to the file.
        setTimeout(() => {
          // For Firefox it is necessary to delay revoking the ObjectURL
          URL.revokeObjectURL(blobURL);
        }, 1000);
        Swal.close();
      } else if (fileType === "xlsx") {
        const compatibleData = data.map((row) => {
          const obj = {};
          header.map((col, index) => {
            obj[col] = row[col];
          });
          return obj;
        });

        let wb = XLSX.utils.book_new();
        let ws1 = XLSX.utils.json_to_sheet(compatibleData, {
          header,
        });
        XLSX.utils.book_append_sheet(wb, ws1, "React Table Data");
        XLSX.writeFile(wb, `${fileName}.xlsx`);
        Swal.close();
        // Returning false as downloading of file is already taken care of
        return false;
      }
      if (fileType === "pdf") {
        const compatibleData = data.map((row) => {
          return [row["Name"], row["Code"],row["Duration (Weeks)"],row["Credits"]];
        });
        const doc = new JsPDF();
        doc.autoTable({
          head: [header],
          body: compatibleData,
          styles: {
            minCellHeight: 10,
            color : "white",
            minCellWidth: 5,
            halign: "left",
            fontSize: 8,
          },
        });
        doc.save(`${fileName}.pdf`);
        Swal.close();
        return false;
      }

    }).catch(error => {
      console.log("error -----> ", error);
    })




  };

  const handleSearchFilter = (e) => {
    const value = e.target.value;
    setSearch(value);
  };

  const myNameFilter = (a, b) => {
    return a.SAQA_Name &&
      a.SAQA_Name.toLowerCase() > b.SAQA_Name &&
      b.SAQA_Name.toLowerCase()
      ? 1
      : -1;
  };
  const myCodeFilter = (a, b) =>
    a.Code.toLowerCase() > b.Code.toLowerCase() ? 1 : -1;
  const myNQFFilter = (a, b) =>
    Number(a.NQF_Level) > Number(b.NQF_Level) ? 1 : -1;
  const columns = useMemo(() => [
    {
      name: "Name",
      selector: "name",
      sortable: true,
      cell: (row) => (
        <Link
          className="as-text-blue curser feature-name"
          
          to={`/program-management-center/modules/module/open/${row.Id}`}
          title={row.name}
        >
          <span className="textLimit100">{row.name}</span>
        </Link>
      ),
    },
    {
      name: "Code",
      selector: "Code",
      sortable: true,
      cell: (row) => (
        <div className="ticket-id">
          {row.Code ? (
            <span title={row.Code} className="overflow-ellipsis2 as-text-blue">
              {TrimText(row.Code, 25)}
            </span>
          ) : (
            "-"
          )}
        </div>
      ),
    },

    {
      name: "Duration (Weeks)",
      selector: "Duration",
      sortable: true,
      cell: (row) => (
        <div className="ticket-id">
          {row.Duration ? (
            <span
              title={row.Duration}
              className="overflow-ellipsis2 as-text-blue"
            >
              {TrimText(row.Duration, 25)}
            </span>
          ) : (
            "-"
          )}
        </div>
      ),
    },
    {
      name: "Credits",
      selector: "credits",
      sortable: true,
      cell: (row) =>
        row.credits ? <div title={row.credits}>{row.credits}</div> : "-",
    },
    {
      name: "Actions",
      selector: "",
      cell: (row) => {
        const isAssigned = tableData?.some((item) => item.Id === row.Id);

        return (
          <div className="assessment-08">
            <div className="as-buttons">
            <Link
                to={`/program-management-center/modules/module/open/${row.Id}`}
                className="btn btn-primary rounded-circle"
                title="Open"
              >
                <i className="fal fa-folder-open"></i>
              </Link>
              <button
                type="button"
                className={`btn rounded-circle ${
                  isAssigned ? "btn-danger" : "btn-primary"
                }`}
                onClick={() => {
                  addProgramme(row, isAssigned ? "delete" : "add"); 
                }}
                title={isAssigned ? "Unassign Page" : "Assign Page"}
              >
                <i className={`fal fa-${isAssigned ? "minus" : "plus"}`}></i>
              </button>
            </div>
          </div>
        );
      },
    },
  ]);

  return (
    <div className="my-tickets-info-list Tickets-main-wrap tickets-new-custom">
      <div className="custom-table-div filter-search-icon card card-table-custom">
        <div className="search-filter-div">
          <div className="search-filter-div-left">
            <div className="system-administration-table table-responsive">
              <div className="table-responsive-div">
                <div
                  id="assessment-table-main_wrapper"
                  className="dataTables_wrapper no-footer"
                >
                  <div
                    id="assessment-table-main_filter"
                    className="dataTables_filter"
                  >
                    <label>
                      <input
                        type="search"
                        className=""
                        placeholder="Search"
                        aria-controls="assessment-table-main"
                        onChange={handleSearchFilter}
                        value={search}
                      />
                    </label>
                    <div className="filter-eff filter-data-btn">
                      <button className="filter-buttons">
                        <i className="fal fa-filter"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="filter-button-group">
                <div className="reset-btn-group">
                  <div className="button-reset dropdown-comman">
                    <button
                      className="btn btn-primary"
                      onClick={() => resetFilter()}
                      title="Reset"
                    >
                      <i className="fal fa-redo"></i>Reset
                    </button>
                  </div>
                  <div className="files-export-group">
                    <button
                      type="button"
                      className="btn btn-files"
                      onClick={() => {
                        exportData("xlsx", "PMC");
                      }}
                      title="Export spreadsheet"
                    >
                      <i className="fal fa-file-excel icon"></i>
                    </button>

                    <button
                      type="button"
                      className="btn btn-files"
                      onClick={() => {
                        exportData("csv", "PMC");
                      }}
                      title="Export CSV"
                    >
                      <i className="fal fa-file-csv icon"></i>
                    </button>

                    <button
                      type="button"
                      className="btn btn-files"
                      onClick={() => {
                        exportData("pdf", "PMC");
                      }}
                      title="Export PDF"
                    >
                      <i className="fal fa-file-pdf icon"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <DataTable
          data={tableData1}
          columns={columns}
          pagination={true}
          sortServer={true}
          paginationServer={true}
          progressComponent={<SkeletonTicketList />}
          progressPending={loading}
          paginationTotalRows={totalRows1}
          noDataComponent={Str.noRecord}
          onSort={handleSort}
          onChangeRowsPerPage={handlePerRowsChange}
          onChangePage={handlePageChange}
          defaultSortAsc={true}
          defaultSortField={"name"}
          paginationRowsPerPageOptions={TABLE_ROWS_PER_PAGE}
        />
      </div>
    </div>
  );
}

export default CreateStudyPathModuleModel;
